import { Injectable } from '@angular/core';

import { lastValueFrom, map } from 'rxjs';
import { ConnectionTypesApiService } from 'src/app/core/services/http/connection-types-api.service';
import { ConnectionType } from 'src/app/shared/models/connection-type';
import { ConnectionTypeResponse } from '../../models/connection-type-response';
import AutoMapperService from './auto-mapper.service';

@Injectable({
    providedIn: 'root'
})
export class ConnectionTypesService {
    private cachedConnectionTypes: ConnectionType[] | null = null;
    private cachedConnectionTypesRequest: Promise<ConnectionType[]> | null = null;

    constructor(private api: ConnectionTypesApiService) {}

    public async getConnectionTypes(): Promise<Array<ConnectionType>> {
        try {
            if (this.cachedConnectionTypes) {
                return Promise.resolve(this.cachedConnectionTypes);
            } else if (this.cachedConnectionTypesRequest) {
                return this.cachedConnectionTypesRequest;
            } else {
                this.cachedConnectionTypesRequest = lastValueFrom(
                    this.api.getConnectionTypes().pipe(
                        map(response => {
                            return (
                                response?.map(data =>
                                    AutoMapperService.mapToApplicationModel<ConnectionTypeResponse, ConnectionType>(
                                        data
                                    )
                                ) ?? []
                            );
                        })
                    )
                );
                this.cachedConnectionTypes = await this.cachedConnectionTypesRequest;
                return Promise.resolve(this.cachedConnectionTypes);
            }
        } catch (e) {
            this.clearCache();
            throw e;
        }
    }

    public clearCache() {
        this.cachedConnectionTypes = null;
        this.cachedConnectionTypesRequest = null;
    }
}
